import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKongregateComponent } from './simple-icons-kongregate.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKongregateComponent ],
    exports:      [ SimpleIconsKongregateComponent ],
    bootstrap:    []
})
export class SimpleIconsKongregateModule {}
